
<ng4-loading-spinner [threshold]="1000" [timeout]="10000" [zIndex]="9999"></ng4-loading-spinner>